<template>
  <div>
    <div class="container-fluid">
      <AlertBannerRecords class="mt-4" path="/vehicles" :message="vehiclesMessage" />
      <AlertBannerRecords class="mt-4" path="/maestro/chronotachographs" :message="scheduleMessage" />
      <div class="row mt-4 mb-4">

        <div class="col-md-6">
          <div class="col-md-6 pl-0">
            <label for="entity-status">Status do veículo</label>
            <select @change="initializeData" v-model="entityStatusId" id="entity-status" class="form-control">
              <option value="">Todos</option>
              <option v-for="status in entityStatuses" :key="status.id" :value="status.id">
                {{ status.friendlyName }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-6 float-right" style="display:flex; align-items: center; justify-content: end">
          <router-link
              tag="button"
              to="/cm-crono"
              class="btn btn-primary btn-xl ml-3"
          >
            Acessar aplicativo
          </router-link>
        </div>
      </div>

    </div>

    <div class="container-fluid">
      <div class="row">

        <!-- Status -->
        <div class="col-md-4" v-for="situation in listSituation" :key="situation.title">
          <Card :data="situation" :loading="objectLoad.situation" :dataSum="false"/>
        </div>
      </div>

      <!-- Vehicle Table -->
      <div class="row">
        <div class="col-md-12 mt-4 mb-2">
          <h5><strong>Próximos ao vencimento</strong></h5>
        </div>

        <!-- Search -->
        <div class="col-md-4">
          <input
            class="input form-control"
            @keypress.enter="find()"
            v-model="generic"
            placeholder="Pesquisar por Placa ou Renavam"
          >
          <search-icon @click="find()" class="icon icon-within"/>
        </div>

        <Vehicles
          :vehicles="vehicles"
          :loading="objectLoad.vehicles"
          :endDate="endDate"
          :startDate="startDate"
          :periodType="periodType"
          :entityStatusId="entityStatusId"
        />

        <div class="col-md-12">
          <Pagination
            v-model="meta.currentPage"
            :totalCount="meta.totalCount"
            :totalPages="meta.totalPages"
            @pagination="pagination"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Card from '@/components/dashboard/dashboard_cm_frotas/Card'
  import Entity from '@/models/EntityProxy'
  import Vehicles from '@/components/dashboard/dashboard_cm_crono/Vehicles'
  import Pagination from '@/components/shares/specialTag/Pagination.vue';
  import AlertBannerRecords from '@/components/shares/AlertBannerRecords.vue';

  import GetAccount from '../../mixins/GetAccount'
  import { SearchIcon } from 'vue-feather-icons'
  import { VEHICLE_STATUS, VEHICLE_STATUS_OPTIONS } from '@/utils/vehicleStatus'
  import { CRONO_SITUATION } from '@/utils/cronoSituation'

  export default {
    name: 'DashboardCMCrono',
    components: { Card, Pagination, Vehicles, SearchIcon, AlertBannerRecords },
    computed: {
      queryGeneric() {
        return this.generic ? { generic: this.generic } : {}
      },
    },
    created() {
      this.loadEntityStatus()
      this.initializeData()
    },
    data: () => ({
      startDate: '',
      endDate: '',
      periodType: 'valid_at',
      generic: '',
      entityStatusId: VEHICLE_STATUS.ENABLED,
      entityStatuses: [],
      vehiclesMessage: 'Ainda não existem veículos cadastrados no sistema. <a href="/definitions?tab=vehicles">Clique aqui</a> para ir para o cadastro de veículos.',
      scheduleMessage: 'Ainda não existem cronotacógrafos registrados no sistema. <a href="/cm-crono/configuracoes">Clique aqui</a> para ir para o agendamento de consultas.',
      meta: {
        perPage: 5,
        currentPage: 1
      },
      listSituation: [
        {title: 'Ativos', count: 0, color: 'green'},
        {title: 'A vencer', count: 0, color: 'yellow'},
        {title: 'Vencidos', count: 0, color: 'red'},
      ],
      objectLoad: {
        situation: false,
        vehicles: false,
      },
      vehicles: []
    }),
    methods: {
      async initializeData() {
        const methods = [
          this.loadSituation,
          this.loadVehicles
        ]

        for (const method of methods)
          await method()
      },
      find() {
        this.meta.currentPage = 1
        this.loadVehicles()
      },
      loadEntityStatus() {
        this.entityStatuses = VEHICLE_STATUS_OPTIONS
      },
      loadSituation() {
        this.objectLoad.status = true
        const params = { query: { entity_status_id: this.entityStatusId } }
        return this.axios.get('maestro/chronotachographs/count_situation', { params })
          .then(response => response.data)
          .then(situation => {
            const active = { count: situation[CRONO_SITUATION.ACTIVE] || 0, title: 'ATIVOS', color: 'green' }
            const expiring = { count: situation[CRONO_SITUATION.EXPIRING] || 0, title: 'A VENCER', color: 'yellow' }
            const expired = { count: situation[CRONO_SITUATION.EXPIRED] || 0, title: 'VENCIDOS', color: 'red' }
            this.listSituation = [active, expiring, expired]
          })
          .finally(() => this.objectLoad.status = false)
      },
      loadVehicles() {
        const params = {
          query: { ...this.queryGeneric, entity_status_id: this.entityStatusId },
          page: this.meta.currentPage,
          per_page: this.meta.perPage,
          order: ['valid_at', 'asc']
        }
        this.objectLoad.vehicles = true

        return this.axios.get('maestro/chronotachographs/last', { params })
          .then(response => {
            this.vehicles = Entity.build(response.data)
            this.meta = Entity.build(response.meta)
          })
          .finally(() => this.objectLoad.vehicles = false)
      },
      pagination(page) {
        this.meta.currentPage = page
        this.loadVehicles()
      },
    },
    mixins: [GetAccount]
  }
</script>

<style scoped>

</style>
